import { useMemo } from "react";

const INVALID_BOARD_MESSAGE =
  "The board you are looking for doesn't exist.";
const PERMISSION_DENIED_MESSAGE =
  "You are not authorized to access this board.";

export function useBoardPermissions(board, error, isInvalidBoardRoute = false) {
  return useMemo(() => {
    const workflowId = board?.workflow_id ?? null;
    const ownerId = board?.owner_user_id ?? null;
    const isPermissionDenied =
      error?.response?.data?.message === "Permision Denied";
    const errorMessage =
      isPermissionDenied
        ? PERMISSION_DENIED_MESSAGE
        : error || isInvalidBoardRoute
          ? INVALID_BOARD_MESSAGE
          : null;

    return {
      ownerId,
      workflowId,
      hasWorkflow: Boolean(workflowId),
      errorMessage,
      isPermissionDenied,
    };
  }, [board, error, isInvalidBoardRoute]);
}
